import React from "react";
import PropTypes from "prop-types";
import COLORS from "../../../constants/Colors";
import styled from "@emotion/styled/macro";
import { InputAdornment, InputLabel, TextField } from "@mui/material";

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "transparent",
    },
    "&:hover fieldset": {
      borderColor: COLORS.PRIMARY,
    },
    "&.Mui-focused fieldset": {
      borderColor: COLORS.PRIMARY,
    },
  },
});

const WheelzTextInput = ({
  label = "Input Field",
  width = "100%",
  readOnly = false,
  numberInput = false,
  phoneNoInput = false,
  showAdornment = false,
  noLabel = false,
  fontWeight = 600,
  fontSize = 18,
  padding = "0px 10px",
  onEnterFunc,
  customStartAdornment,
  customEndAdornment,
  disabled,
  textAlign = "left",
  letterSpacing = "1px",
  primaryColorLabel = false,
  ...rest // Capture all other props not explicitly defined
}) => {
  const commonStyle = {
    border: "none",
    borderRadius: 0,
    backgroundColor: disabled
      ? "var(--input-field-disabled)"
      : "var(--input-field-active)",
    color: "var(--text-color)",
    padding: padding,
    fontFamily: "inherit",
    fontWeight: fontWeight,
    fontSize: fontSize,
    letterSpacing: letterSpacing,
  };
  const handleInputFieldKeyDown = (event) => {
    if (onEnterFunc) {
      if (event.key === "Enter") {
        onEnterFunc(); // Call the additional function
      }
    }
    if (numberInput) {
      // Allow actions: copy (c), cut (x), paste (v), select all (a), and undo (z) with Ctrl or Command key
      if (
        (event.ctrlKey || event.metaKey) &&
        ["c", "x", "v", "a", "z", "r"].includes(event.key.toLowerCase())
      ) {
        return; // Do nothing, allow the key combination
      }

      // Allow navigation and control keys: backspace, delete, arrows, tab, escape
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Escape",
      ];
      if (allowedKeys.includes(event.key)) {
        return; // Do nothing, allow the key
      }

      // Prevent input if the key is not a digit
      if (!event.key.match(/^\d+$/)) {
        event.preventDefault();
      }
    }
  };
  const inputLabelStyle = {
    color: primaryColorLabel ? "var(--primary-purple)" : "var(--text-color)",
    fontFamily: "inherit",
    fontWeight: "500",
    mb: "10px",
  };

  return (
    <div style={{ width: width }}>
      {!noLabel && <InputLabel sx={inputLabelStyle}>{label}</InputLabel>}
      <CustomTextField
        disabled={disabled}
        fullWidth
        variant="outlined"
        onKeyDown={handleInputFieldKeyDown}
        inputProps={{
          style: {
            textAlign: textAlign,
          },
        }}
        InputProps={{
          style: commonStyle,
          readOnly: readOnly,
          endAdornment: customEndAdornment,
          startAdornment: customStartAdornment
            ? customStartAdornment
            : phoneNoInput &&
              showAdornment && (
                <InputAdornment position="start" sx={{ ml: "10px" }}>
                  <span>+91</span>
                </InputAdornment>
              ),
        }}
        {...rest}
      />
    </div>
  );
};

WheelzTextInput.propTypes = {
  readOnly: PropTypes.bool,
  label: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  numberInput: PropTypes.bool,
  phoneNoInput: PropTypes.bool,
  showAdornment: PropTypes.bool,
  onEnterFunc: PropTypes.func,
  noLabel: PropTypes.bool,
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  customStartAdornment: PropTypes.element,
  customEndAdornment: PropTypes.element,
  disabled: PropTypes.bool,
  textAlign: PropTypes.string,
  letterSpacing: PropTypes.string,
  primaryColorLabel: PropTypes.bool,
};

export default WheelzTextInput;
